import FileService from '../services/file-service'

export default {
  install (Vue) {
    Vue.prototype.$file = new FileService(new Vue())
  },
}
